<template>
  <v-card>
    <v-card-title> Assets </v-card-title>
    <v-card-text>
      <p>
        <span v-if="testator.worldWideAssets">World wide assets</span>
        <span v-else-if="testator.worldWideAssets == false"
          >{{ willCountry }} assets only</span
        >
        <span v-else
          >Testator has not selected between world wide assets or local assets
          only</span
        >
      </p>

      <p v-if="testator.assetsOptOut">Testator opted out of adding assets</p>
      <p v-else-if="noAssetsPresent">No assets listed and not opted out</p>
      <div v-else>
        <div v-if="testator.properties.length" class="mb-4">
          <h4>Properties:</h4>
          <ul>
            <li
              v-for="property in testator.properties"
              :key="'Property' + property.id"
            >
              {{ property.displayName }}
            </li>
          </ul>
        </div>
        <div v-if="testator.vehicles.length" class="mb-4">
          <h4>Vehicles:</h4>
          <ul>
            <li
              v-for="vehicle in testator.vehicles"
              :key="'Vehicle' + vehicle.id"
            >
              {{ vehicle.displayName }}
            </li>
          </ul>
        </div>
        <div v-if="testator.financialAssets.length" class="mb-4">
          <h4>Investments:</h4>
          <ul>
            <li
              v-for="financialAsset in testator.financialAssets"
              :key="'FinancialAsset' + financialAsset.id"
            >
              {{ financialAsset.displayName }}
            </li>
          </ul>
        </div>
        <div v-if="testator.otherAssets.length" class="mb-4">
          <h4>Other assets:</h4>
          <ul>
            <li
              v-for="otherAsset in testator.otherAssets"
              :key="'OtherAsset' + otherAsset.id"
            >
              {{ otherAsset.displayName }}
            </li>
          </ul>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'AssetsCard',
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    computed: {
      noAssetsPresent() {
        return (
          !this.testator.properties.length &&
          !this.testator.vehicles.length &&
          !this.testator.financialAssets.length &&
          !this.testator.otherAssets.length
        );
      },
      willCountry() {
        return this.testator.willCountry == 'ZA'
          ? 'South African'
          : 'United Kingdom';
      },
    },
  };
</script>
